import { SEARCH_PARAM_UNIT_ID } from 'routes/(common_search_params)/-searchParams'
import { SEARCH_PARAM_ORG_ID } from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

export const SEARCH_PARAM_DASHBOARD_CONFIG_ID = 'dashboardConfigId'
export const SEARCH_PARAM_GROUP = 'group'

export const libraDashboardSearchParamsSchema = z.object({
  [SEARCH_PARAM_ORG_ID]: z.string().optional(),
  [SEARCH_PARAM_DASHBOARD_CONFIG_ID]: z.string().optional(),
  [SEARCH_PARAM_GROUP]: z.string().optional(),
  [SEARCH_PARAM_UNIT_ID]: z.string().optional(),
})
